import { useEffect, useState } from 'react';

// Téléphone : le panneau du chat occupe exactement la zone visible de l'écran (window.visualViewport), qui se réduit
// quand le clavier s'ouvre — Chrome Android et Safari ne réduisent pas 100vh/100dvh pour le clavier, d'où un champ de
// saisie qui partait sous le clavier et la page qui apparaissait derrière. La page de fond ne défile plus.
const PHONE = '(max-width: 639px)';

const useVisibleViewport = (active) => {
  const [box, setBox] = useState(null);

  useEffect(() => {
    if (!active || typeof window === 'undefined' || !window.visualViewport) return undefined;
    const viewport = window.visualViewport;
    const phone = window.matchMedia(PHONE);
    const update = () => setBox(phone.matches
      ? { top: Math.max(0, viewport.offsetTop), height: Math.round(viewport.height) }
      : null);
    const { body, documentElement } = document;
    const previous = [body.style.overflow, documentElement.style.overflow];
    const lock = () => {
      body.style.overflow = phone.matches ? 'hidden' : previous[0];
      documentElement.style.overflow = phone.matches ? 'hidden' : previous[1];
    };
    update();
    lock();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    const onPhoneChange = () => { update(); lock(); };
    phone.addEventListener('change', onPhoneChange);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      phone.removeEventListener('change', onPhoneChange);
      [body.style.overflow, documentElement.style.overflow] = previous;
    };
  }, [active]);

  return box;
};

export default useVisibleViewport;
